import EstadoHistoricoSimpleTable from "./EstadoHistoricoSimpleTable";

export {EstadoHistoricoSimpleTable}
export default EstadoHistoricoSimpleTable
